<template>
  <qtm-dialog-card
    v-bind="$attrs"
    actions-class="qtm-border-top"
    closable
    color="white"
    fullscreen
    header-background="white"
    height="90vh"
    padding-bottom="0"
    title-class="qtm-border-bottom"
    :transition="false"
    width="95vw"
    @update:model-value="$emit('update:model-value', $event)"
  >
    <template v-slot:title>
      <qtm-btn class="px-0" prepend-icon="mdi-chevron-left" tertiary @click="$emit('update:model-value', false)">
        Back
      </qtm-btn>
    </template>
    <template v-slot:title-center>
      <quote-progress v-if="withProgress" model-value="matching" />
    </template>
    <match-items-side-by-side
      :action-target="actionTarget!"
      :item-type="itemType"
      :items-to-match="itemsToMatch"
      :items-to-match-header="itemsToMatchHeader"
      :loading="localLoading || loading"
      :match-item-type="matchItemType"
      :match-items="matchItems"
      :match-items-header="matchItemsHeader"
      :order-id="orderId"
      :units="units"
      @update:items-to-match="onUpdateItems"
      @update:loading="localLoading = $event"
    />
    <template v-slot:actions>
      <qtm-btn :loading="localLoading || loading" size="x-large" tertiary @click="$emit('update:model-value', false)">
        Cancel
      </qtm-btn>
      <div ref="action-target" />
    </template>
  </qtm-dialog-card>
</template>

<script setup lang="ts">
import type { LineItem } from '@quotetome/materials-api'
import MatchItemsSideBySide from '@/components/items/match-items-side-by-side.vue'
import QuoteProgress from '@/components/quotes/quote-progress.vue'

export interface Props {
  itemsToMatch?: LineItem[]
  itemsToMatchHeader: string
  itemType: string
  loading?: boolean
  matchItems?: LineItem[]
  matchItemsHeader: string
  matchItemType: string
  orderId?: number | null
  units?: any[]
  withProgress?: boolean
}

withDefaults(defineProps<Props>(), {
  itemsToMatch: () => [],
  matchItems: () => [],
  orderId: null,
  units: () => [],
})
const emit = defineEmits(['update:items-to-match', 'update:model-value'])

const actionTarget = useTemplateRef('action-target')
const localLoading = ref(false)

const onUpdateItems = (items: LineItem[]) => {
  emit('update:items-to-match', items)
  emit('update:model-value', false)
}
</script>
